<template>
  <div class="loading-spinner">
    <img src="../assets/logo.svg" alt="Loading..." class="spinner-logo" />
    <p>Loading... {{ route.path }} ... </p>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<style scoped>
.loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 1rem;
}

.spinner-logo {
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

p {
  color: #666;
  font-size: 0.9rem;
}
</style> 